const ADDON_DELIVERY_MODES = {
  FOR_EVERY_BAG: 'EVERY',
  FOR_FIRST_BAG: 'FIRST',
};

export default ADDON_DELIVERY_MODES;
